import type { ButtonHTMLAttributes } from 'react';

type Variant = 'primary' | 'secondary' | 'ghost';

const variantClasses: Record<Variant, string> = {
  primary: 'bg-seal-500 text-paper-50 hover:bg-seal-400 disabled:bg-seal-500/30 disabled:text-paper-50/50',
  secondary:
    'border border-manuscript-line-strong bg-paper-100 text-manuscript-ink hover:bg-paper-200 disabled:text-manuscript-ink-faint',
  ghost: 'text-manuscript-ink-soft hover:bg-paper-200 disabled:text-manuscript-ink-faint',
};

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
}

export function Button({ variant = 'primary', className = '', ...props }: ButtonProps) {
  return (
    <button
      className={`font-manuscript inline-flex items-center justify-center rounded-sm px-4 py-2.5 text-sm font-semibold transition-colors disabled:cursor-not-allowed focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-seal-500/50 focus-visible:ring-offset-1 ${variantClasses[variant]} ${className}`}
      {...props}
    />
  );
}
